<template>
  <header class="header">
    <ContentDivisor class="divisor" v-if="isContentDivisorVisible" />
    <PrimaryTitle>
      <slot name="title" />      
    </PrimaryTitle>
    <SecondaryTitle
      v-if="$slots.subtitle"
      class="subtitle"
    >
      <slot name="subtitle" />
    </SecondaryTitle>
  </header>
</template>

<script>
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
  import SecondaryTitle from '@/components/text/titles/SecondaryTitle'
  import ContentDivisor from '@/components/layout/ContentDivisor'

  export default {
    components: {
      PrimaryTitle,
      SecondaryTitle,
      ContentDivisor,
    },
    props: {
      isContentDivisorVisible: {
        type: Boolean,
        default:true

      }
    },
  }
</script>

<style scoped lang="scss">
  .header {
    text-align: center;
    margin-bottom: 3.125rem;

    .divisor { margin-bottom: 25px }

    .subtitle { margin-top: 10px }
  }
</style>